var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeachlaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1305 4.00125C23.2598 -1.12802 31.576 -1.12802 36.7052 4.00126L50.9663 18.2623C56.0956 23.3916 56.0956 31.7078 50.9663 36.8371L36.7052 51.0981C31.5759 56.2274 23.2598 56.2274 18.1305 51.0981L3.86941 36.8371C-1.25986 31.7078 -1.25985 23.3916 3.86942 18.2623L18.1305 4.00125Z",
    fill: "#5EDA12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7645 31.7744C38.0342 31.7744 42.313 27.5314 42.3708 22.2754L32.6565 31.7738C32.6925 31.7742 32.7284 31.7744 32.7645 31.7744Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8077 18.8213C33.5379 18.8213 29.2592 23.0643 29.2013 28.3203L38.9156 18.8219C38.8797 18.8215 38.8437 18.8213 38.8077 18.8213Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3708 18.8203H38.9167V22.2745H42.3708V18.8203Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6569 28.3203H29.2027V31.7745H32.6569V28.3203Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9167 18.8203L42.3708 22.2745L32.656 31.7735L29.2018 28.3193L38.9167 18.8203Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2022 32.7857V30.8789H31.2521V32.7857C31.2521 35.1734 29.9888 37.3829 27.9311 38.5941L27.5271 38.8319L26.4873 37.0652L26.8912 36.8275L27.4112 37.7108L26.8912 36.8275C28.3231 35.9847 29.2022 34.4472 29.2022 32.7857Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1375 32.1345C17.9216 32.1345 13.6864 27.9348 13.6292 22.7324L23.2444 32.1339C23.2088 32.1343 23.1732 32.1345 23.1375 32.1345Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1512 19.3147C22.3671 19.3147 26.6023 23.5144 26.6595 28.7168L17.0443 19.3153C17.0799 19.3149 17.1155 19.3147 17.1512 19.3147Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6267 19.3145H17.0457V22.7334H13.6267V19.3145Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2432 28.7168H26.6621V32.1357H23.2432V28.7168Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0457 19.3145L13.6267 22.7334L23.2425 32.1355L26.6614 28.7166L17.0457 19.3145Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2804 29.1402C22.9752 29.4455 22.4802 29.4455 22.1749 29.1402L17.1719 24.1372C16.8666 23.8319 16.8666 23.337 17.1719 23.0317C17.4772 22.7264 17.9721 22.7264 18.2774 23.0317L23.2804 28.0347C23.5857 28.34 23.5857 28.835 23.2804 29.1402Z",
    fill: "#5EDA12"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7636 28.6461C33.0689 28.9514 33.5639 28.9514 33.8692 28.6461L38.8722 23.6431C39.1775 23.3378 39.1775 22.8428 38.8722 22.5376C38.5669 22.2323 38.0719 22.2323 37.7667 22.5376L32.7636 27.5406C32.4583 27.8459 32.4583 28.3408 32.7636 28.6461Z",
    fill: "#5EDA12"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6267 40.7518C25.4947 40.7518 26.1983 40.0482 26.1983 39.1802C26.1983 38.3122 25.4947 37.6086 24.6267 37.6086C23.7587 37.6086 23.0551 38.3122 23.0551 39.1802C23.0551 40.0482 23.7587 40.7518 24.6267 40.7518ZM24.6267 42.6279C26.5309 42.6279 28.0745 41.0843 28.0745 39.1802C28.0745 37.276 26.5309 35.7324 24.6267 35.7324C22.7226 35.7324 21.179 37.276 21.179 39.1802C21.179 41.0843 22.7226 42.6279 24.6267 42.6279Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0595 33.9258C28.1566 35.8959 26.6625 35.7318 24.6267 35.7318L28.567 37.8661L29.0595 33.9258Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8805 36.8809C29.4153 37.4555 28.4029 38.6868 27.9104 40.2465L26.9253 37.045L29.8805 36.8809Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachlaLogo);
export default __webpack_public_path__ + "static/media/teachla-logo.ef77ccddd470882cb2458e2c02f01149.svg";
export { ForwardRef as ReactComponent };